import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';

@Component({
  selector: 'facebook-photos',
  templateUrl: './facebook.component.html',
  styleUrls: ['./facebook.component.scss']
})
export class FacebookComponent implements OnInit {

  fackbookPost: Object;
  fackbookPostLink: string;
  facebookPostName: string;
  public errorMsg;

  constructor(private _http: HttpService) { }

  ngOnInit(): void {
    this._http.facebookPost().subscribe(
      data => {
        this.fackbookPost = data.data;
        this.fackbookPostLink = data.data[0].link;
        this.facebookPostName = data.data[0].name;
        // this.fackbookPost = data.data.slice(0,4);
        console.log(data.data);
        console.log(this.fackbookPostLink);
        console.log(this.facebookPostName);
      },
      error => this.errorMsg = error
    );
  } 
}
